"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[455],{

/***/ 36819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ TradeType; },
/* harmony export */   "k": function() { return /* binding */ toggleTradeType; }
/* harmony export */ });
var TradeType;
(function(TradeType) {
    TradeType[TradeType["EXACT_INPUT"] = 0] = "EXACT_INPUT";
    TradeType[TradeType["EXACT_OUTPUT"] = 1] = "EXACT_OUTPUT";
})(TradeType || (TradeType = {}));
var toggleTradeType = function(currentTradeType) {
    switch(currentTradeType){
        case TradeType.EXACT_INPUT:
            return TradeType.EXACT_OUTPUT;
        case TradeType.EXACT_OUTPUT:
            return TradeType.EXACT_INPUT;
    }
};


/***/ }),

/***/ 4393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ useBestTrade; }
});

// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(41050);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(43692);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(61557);
// EXTERNAL MODULE: ./utils/token/formatBalance.ts
var formatBalance = __webpack_require__(95487);
;// CONCATENATED MODULE: ./utils/swap/computeBestTradePath.ts




/**
 * search for the path and calc amountOut which
* uses an exact amount of input tokens for as many output tokens as possible,
  */ var computeBestTradePathForExactAmountIn = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var tokenIn, amountIn, possiblePaths, router, maxAmountOut, bestTradePath, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, routePath, ref, amount, _outAmount, outAmount, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    tokenIn = param.tokenIn, amountIn = param.amountIn, possiblePaths = param.possiblePaths, router = param.router;
                    maxAmountOut = (0,bignumber/* default */.Z)(0);
                    bestTradePath = [];
                    if (!amountIn.gt(0)) {
                        return [
                            2
                        ];
                    }
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = possiblePaths[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    routePath = _step.value;
                    return [
                        4,
                        router === null || router === void 0 ? void 0 : router.query.getAmountsOut((0,formatBalance/* getDisplayDecimalAmount */.jV)(amountIn, tokenIn === null || tokenIn === void 0 ? void 0 : tokenIn.decimal), routePath)
                    ];
                case 3:
                    amount = _state.sent();
                    if (!((ref = amount === null || amount === void 0 ? void 0 : amount.value.ok) === null || ref === void 0 ? void 0 : ref.ok)) {
                        console.error("could not get amountout: ", amount.value);
                        return [
                            3,
                            4
                        ];
                    }
                    _outAmount = amount.value.ok.ok.at(-1);
                    if (!_outAmount) {
                        return [
                            2
                        ];
                    }
                    outAmount = new bignumber/* default */.Z(_outAmount);
                    if (outAmount.gt(maxAmountOut)) {
                        bestTradePath = routePath;
                        maxAmountOut = outAmount;
                    }
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2,
                        {
                            bestTradePath: bestTradePath,
                            maxAmountOut: maxAmountOut
                        }
                    ];
            }
        });
    });
    return function computeBestTradePathForExactAmountIn(_) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * computeBestTradePathForAmountOut search for the path which
 * receives an exact amount of output tokens for as few input tokens as possible
  */ var computeBestTradePathForExactAmountOut = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var tokenOut, amountOut, possiblePaths, router, minAmountIn, bestTradePath, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, routePath, ref, amount, _amountIn, amountIn, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    tokenOut = param.tokenOut, amountOut = param.amountOut, possiblePaths = param.possiblePaths, router = param.router;
                    minAmountIn = (0,bignumber/* default */.Z)(0);
                    bestTradePath = [];
                    if (!amountOut.gt(0)) {
                        return [
                            2
                        ];
                    }
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = possiblePaths[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    routePath = _step.value;
                    return [
                        4,
                        router === null || router === void 0 ? void 0 : router.query.getAmountsIn((0,formatBalance/* getDisplayDecimalAmount */.jV)(amountOut, tokenOut === null || tokenOut === void 0 ? void 0 : tokenOut.decimal), routePath)
                    ];
                case 3:
                    amount = _state.sent();
                    if (!((ref = amount === null || amount === void 0 ? void 0 : amount.value.ok) === null || ref === void 0 ? void 0 : ref.ok)) {
                        console.error("could not get amountout: ", amount.value);
                        return [
                            3,
                            4
                        ];
                    }
                    _amountIn = amount === null || amount === void 0 ? void 0 : amount.value.ok.ok.at(0);
                    amountIn = new bignumber/* default */.Z(_amountIn || "0");
                    if (!amountIn.gt(0)) {
                        return [
                            2
                        ];
                    }
                    if (minAmountIn.eq(0) || amountIn.lt(minAmountIn)) {
                        bestTradePath = routePath;
                        minAmountIn = amountIn;
                    }
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2,
                        {
                            bestTradePath: bestTradePath,
                            minAmountIn: minAmountIn
                        }
                    ];
            }
        });
    });
    return function computeBestTradePathForExactAmountOut(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./constants/tradeType.ts
var constants_tradeType = __webpack_require__(36819);
;// CONCATENATED MODULE: ./hooks/graph/useBestTradeRoutePath.ts



var useBestTradeRoutePath = function(param) {
    var tokenIn = param.tokenIn, amountIn = param.amountIn, tokenOut = param.tokenOut, amountOut = param.amountOut, possiblePaths = param.possiblePaths, router = param.router, tradeType = param.tradeType;
    var ref = (0,react.useState)(), bestTradePath = ref[0], setBestTrandePath = ref[1];
    var ref1 = (0,react.useState)(), maxAmountOut = ref1[0], setMaxAmountOut = ref1[1];
    var ref2 = (0,react.useState)(), minAmountIn = ref2[0], setMinAmountIn = ref2[1];
    (0,react.useEffect)(function() {
        if (!tokenIn || !amountIn || !possiblePaths || !router) {
            return;
        }
        if (tradeType != constants_tradeType/* TradeType.EXACT_INPUT */.Y.EXACT_INPUT) {
            return;
        }
        computeBestTradePathForExactAmountIn({
            tokenIn: tokenIn,
            amountIn: amountIn,
            possiblePaths: possiblePaths,
            router: router
        }).then(function(result) {
            if (result) {
                var path = result.bestTradePath, amount = result.maxAmountOut;
                setBestTrandePath(path);
                setMaxAmountOut(amount);
            }
        });
    }, [
        amountIn,
        possiblePaths,
        router,
        tokenIn,
        tradeType
    ]);
    (0,react.useEffect)(function() {
        if (!tokenOut || !amountOut || !possiblePaths || !router) {
            return;
        }
        if (tradeType != constants_tradeType/* TradeType.EXACT_OUTPUT */.Y.EXACT_OUTPUT) {
            return;
        }
        computeBestTradePathForExactAmountOut({
            tokenOut: tokenOut,
            amountOut: amountOut,
            possiblePaths: possiblePaths,
            router: router
        }).then(function(result) {
            if (result) {
                var path = result.bestTradePath, amount = result.minAmountIn;
                setBestTrandePath(path);
                setMinAmountIn(amount);
            }
        });
    }, [
        amountOut,
        possiblePaths,
        router,
        tokenOut,
        tradeType
    ]);
    return (0,react.useMemo)(function() {
        return {
            bestTradePath: bestTradePath,
            maxAmountOut: maxAmountOut,
            minAmountIn: minAmountIn
        };
    }, [
        bestTradePath,
        maxAmountOut,
        minAmountIn
    ]);
};

// EXTERNAL MODULE: ./hooks/token/useWrappedToken.ts
var useWrappedToken = __webpack_require__(94188);
;// CONCATENATED MODULE: ./utils/graph/createGraphForRoutePath.ts
var createGraphForRoutePath = function(graph, _source, _destination, wNativeToken) {
    var routeGraph = graph === null || graph === void 0 ? void 0 : graph.copy();
    routeGraph === null || routeGraph === void 0 ? void 0 : routeGraph.mergeEdge(_source === null || _source === void 0 ? void 0 : _source.address, wNativeToken === null || wNativeToken === void 0 ? void 0 : wNativeToken.address);
    routeGraph === null || routeGraph === void 0 ? void 0 : routeGraph.mergeEdge(_destination === null || _destination === void 0 ? void 0 : _destination.address, wNativeToken === null || wNativeToken === void 0 ? void 0 : wNativeToken.address);
    return routeGraph;
};

;// CONCATENATED MODULE: ./hooks/graph/useCreateGraphForRoutePath.ts



var useCreateGraphForRoutePath = function(param) {
    var graph = param.graph, sourceToken = param.sourceToken, destinationToken = param.destinationToken;
    var wNativeToken = (0,useWrappedToken/* useWrappedNativeToken */.b)();
    return (0,react.useMemo)(function() {
        if (!graph || !sourceToken || !destinationToken || !wNativeToken) {
            return;
        }
        return createGraphForRoutePath(graph, sourceToken, destinationToken, wNativeToken);
    }, [
        graph,
        sourceToken,
        destinationToken,
        wNativeToken
    ]);
};

// EXTERNAL MODULE: ./node_modules/graphology-simple-path/index.js
var graphology_simple_path = __webpack_require__(12732);
;// CONCATENATED MODULE: ./hooks/graph/usePossiblePaths.ts


var usePossiblePaths = function(param) {
    var graph = param.graph, source = param.source, destination = param.destination;
    return (0,react.useMemo)(function() {
        if (!graph || !source || !destination) {
            return;
        }
        return (0,graphology_simple_path/* allSimplePaths */.$Q)(graph, source.address, destination.address);
    }, [
        destination,
        graph,
        source
    ]);
};

// EXTERNAL MODULE: ./hooks/contract/useRouterContract.ts + 9 modules
var useRouterContract = __webpack_require__(30376);
// EXTERNAL MODULE: ./hooks/token/useGetWrappedTokenIfNative.ts
var useGetWrappedTokenIfNative = __webpack_require__(88830);
;// CONCATENATED MODULE: ./hooks/graph/useBestTrade.ts








var useBestTrade = function(param) {
    var tokenA = param.tokenA, tokenB = param.tokenB, amountIn = param.amountIn, amountOut = param.amountOut, graph = param.graph, tradeType = param.tradeType;
    var _tokenA = (0,useGetWrappedTokenIfNative/* useGetWrappedTokenIfNative */.q)(tokenA);
    var _tokenB = (0,useGetWrappedTokenIfNative/* useGetWrappedTokenIfNative */.q)(tokenB);
    var router = (0,useRouterContract/* useRouterContract */.T)();
    var routeGraph = useCreateGraphForRoutePath({
        graph: graph,
        sourceToken: _tokenA,
        destinationToken: _tokenB
    });
    var possiblePaths = usePossiblePaths({
        graph: routeGraph,
        source: _tokenA,
        destination: _tokenB
    });
    var ref = useBestTradeRoutePath({
        tokenIn: _tokenA,
        tokenOut: _tokenB,
        amountIn: amountIn,
        amountOut: amountOut,
        possiblePaths: possiblePaths,
        router: router,
        tradeType: tradeType
    }), bestTradePath = ref.bestTradePath, maxAmountOut = ref.maxAmountOut, minAmountIn = ref.minAmountIn;
    return (0,react.useMemo)(function() {
        return {
            bestTradePath: bestTradePath,
            amountOut: new bignumber/* default */.Z((0,formatBalance/* getDisplayBalanceAmount */.hr)(maxAmountOut, _tokenB === null || _tokenB === void 0 ? void 0 : _tokenB.decimal)),
            amountIn: new bignumber/* default */.Z((0,formatBalance/* getDisplayBalanceAmount */.hr)(minAmountIn, _tokenA === null || _tokenA === void 0 ? void 0 : _tokenA.decimal))
        };
    }, [
        bestTradePath,
        maxAmountOut,
        _tokenB === null || _tokenB === void 0 ? void 0 : _tokenB.decimal,
        minAmountIn,
        _tokenA === null || _tokenA === void 0 ? void 0 : _tokenA.decimal
    ]);
};


/***/ }),

/***/ 61033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ useBuildGraph; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./hooks/useApi.ts + 247 modules
var useApi = __webpack_require__(1544);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5447);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(42299);
// EXTERNAL MODULE: ./constants/chainIdByName.ts
var chainIdByName = __webpack_require__(15817);
// EXTERNAL MODULE: ./constants/tokens/shibuya.ts
var shibuya = __webpack_require__(72623);
;// CONCATENATED MODULE: ./constants/lpTokens/shibuya.ts



var SHIBUYA_LP_TOKENS = {
    apolo_astr: {
        address: "Z6QTdZubAm8SA71XJb1x415e9Q9PtuGcTsgZ4WaVPnhZBUk",
        token: shibuya/* SHIBUYA_TOKENS_BY_SYMBOL.APLO */.B8.APLO,
        quoteToken: shibuya/* SHIBUYA_TOKENS_BY_SYMBOL.wASTAR */.B8.wASTAR,
        chainId: chainIdByName/* chainIdByName.shibuya */.T.shibuya
    },
    usdc_astr: {
        address: "bVZHeY66R45uVm4mi1Y9JBV719YBb7dsyKk1z6m4sWQ57C3",
        token: shibuya/* SHIBUYA_TOKENS_BY_SYMBOL.USDC */.B8.USDC,
        quoteToken: shibuya/* SHIBUYA_TOKENS_BY_SYMBOL.wASTAR */.B8.wASTAR,
        chainId: chainIdByName/* chainIdByName.shibuya */.T.shibuya
    },
    usdt_astr: {
        address: "YNcB5F4p6MbGwQyoUfysmDKD2GWsnp6YjBB73mBB2mG5HjH",
        token: shibuya/* SHIBUYA_TOKENS_BY_SYMBOL.USDT */.B8.USDT,
        quoteToken: shibuya/* SHIBUYA_TOKENS_BY_SYMBOL.wASTAR */.B8.wASTAR,
        chainId: chainIdByName/* chainIdByName.shibuya */.T.shibuya
    },
    usdt_usdc: {
        address: "aBNQSpNjNcRwT6EKiV7Q9n845DuDW2ZthxZQ6DbXghKy41w",
        token: shibuya/* SHIBUYA_TOKENS_BY_SYMBOL.USDT */.B8.USDT,
        quoteToken: shibuya/* SHIBUYA_TOKENS_BY_SYMBOL.USDC */.B8.USDC,
        chainId: chainIdByName/* chainIdByName.shibuya */.T.shibuya
    },
    usdt_aplo: {
        address: "XnZrYMMvJHfrsnYVVt6C9GUpqfNLhazG5CbUt7bVp6yeFhB",
        token: shibuya/* SHIBUYA_TOKENS_BY_SYMBOL.USDT */.B8.USDT,
        quoteToken: shibuya/* SHIBUYA_TOKENS_BY_SYMBOL.APLO */.B8.APLO,
        chainId: chainIdByName/* chainIdByName.shibuya */.T.shibuya
    },
    usdc_aplo: {
        address: "WBRFed3pKnqHfHCgmhMnbekGSRjokDy4CkEEA45duEKsnF5",
        token: shibuya/* SHIBUYA_TOKENS_BY_SYMBOL.USDC */.B8.USDC,
        quoteToken: shibuya/* SHIBUYA_TOKENS_BY_SYMBOL.APLO */.B8.APLO,
        chainId: chainIdByName/* chainIdByName.shibuya */.T.shibuya
    }
};
var BASIC_LPTOKENS_FOR_ROUTE_PATH_SHIBUYA = (0,_define_property/* default */.Z)({}, chainIdByName/* chainIdByName.shibuya */.T.shibuya, [
    SHIBUYA_LP_TOKENS.apolo_astr,
    SHIBUYA_LP_TOKENS.usdt_astr,
    SHIBUYA_LP_TOKENS.usdc_astr,
    SHIBUYA_LP_TOKENS.usdt_usdc,
    SHIBUYA_LP_TOKENS.usdt_aplo,
    SHIBUYA_LP_TOKENS.usdc_aplo, 
]);

// EXTERNAL MODULE: ./constants/tokens/shiden.ts
var shiden = __webpack_require__(52004);
;// CONCATENATED MODULE: ./constants/lpTokens/shiden.ts



var SHIDEN_LP_TOKENS = {
    apolo_sdn: {
        address: "ZecCT7BaZrXYxZrPJypNq3A57PnQACZJwzjPnG9iyPmUe5s",
        token: shiden/* SHIDEN_TOKENS_BY_SYMBOL.APLO */.ne.APLO,
        quoteToken: shiden/* SHIDEN_TOKENS_BY_SYMBOL.wSDN */.ne.wSDN,
        chainId: chainIdByName/* chainIdByName.shiden */.T.shiden
    },
    usdc_sdn: {
        address: "ayNfpxDUZazkrkXhexvKTW6BHBquUztEEZJRH9qT7hrJtyc",
        token: shiden/* SHIDEN_TOKENS_BY_SYMBOL.USDC */.ne.USDC,
        quoteToken: shiden/* SHIDEN_TOKENS_BY_SYMBOL.wSDN */.ne.wSDN,
        chainId: chainIdByName/* chainIdByName.shiden */.T.shiden
    },
    usdt_sdn: {
        address: "WPmuWw7EAdHZM8GvEAvYVFdgRyFj7FY3jcMLRgBB9SeuWtj",
        token: shiden/* SHIDEN_TOKENS_BY_SYMBOL.USDT */.ne.USDT,
        quoteToken: shiden/* SHIDEN_TOKENS_BY_SYMBOL.wSDN */.ne.wSDN,
        chainId: chainIdByName/* chainIdByName.shiden */.T.shiden
    }
};
var BASIC_LPTOKENS_FOR_ROUTE_PATH_SHIDEN = (0,_define_property/* default */.Z)({}, chainIdByName/* chainIdByName.shiden */.T.shiden, [
    SHIDEN_LP_TOKENS.apolo_sdn,
    SHIDEN_LP_TOKENS.usdt_sdn,
    SHIDEN_LP_TOKENS.usdc_sdn, 
]);

;// CONCATENATED MODULE: ./constants/lpTokens/index.ts



var BASIC_LPTOKENS_FOR_ROUTE_PATH = (0,_object_spread/* default */.Z)({}, BASIC_LPTOKENS_FOR_ROUTE_PATH_SHIBUYA, BASIC_LPTOKENS_FOR_ROUTE_PATH_SHIDEN);

;// CONCATENATED MODULE: ./hooks/token/useLPTokensForRoutePath.ts


var useLPTokensForRoutePath = function() {
    var chainId = (0,useApi/* useChainId */.xx)();
    if (!chainId) {
        return [];
    }
    return BASIC_LPTOKENS_FOR_ROUTE_PATH[chainId] || [];
};

// EXTERNAL MODULE: ./node_modules/graphology/dist/graphology.umd.min.js
var graphology_umd_min = __webpack_require__(73528);
var graphology_umd_min_default = /*#__PURE__*/__webpack_require__.n(graphology_umd_min);
;// CONCATENATED MODULE: ./utils/graph/buildGraph.ts

var buildGraph = function(lpTokens) {
    var graph = new (graphology_umd_min_default())({
        type: "undirected",
        multi: true
    });
    lpTokens.forEach(function(lpToken) {
        var quoteToken = lpToken.quoteToken, token = lpToken.token;
        graph.mergeNode(token.address);
        graph.mergeNode(quoteToken.address);
        graph.mergeEdge(token.address, quoteToken.address);
    });
    return graph;
};

;// CONCATENATED MODULE: ./hooks/graph/useBuildGraph.ts



var useBuildGraph = function() {
    var lpTokens = useLPTokensForRoutePath();
    return (0,react.useMemo)(function() {
        return buildGraph(lpTokens);
    }, [
        lpTokens
    ]);
};


/***/ }),

/***/ 68574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ useIdealPriceOfTokenIn; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(43692);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(61557);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./hooks/contract/useFactoryContract.ts + 9 modules
var useFactoryContract = __webpack_require__(1363);
// EXTERNAL MODULE: ./hooks/polkadotExtension/useAccounts.ts + 1 modules
var useAccounts = __webpack_require__(28037);
// EXTERNAL MODULE: ./hooks/useApi.ts + 247 modules
var useApi = __webpack_require__(1544);
// EXTERNAL MODULE: ./utils/contract/getPairContract.ts
var getPairContract = __webpack_require__(65293);
// EXTERNAL MODULE: ./utils/pair/getReserves.ts
var getReserves = __webpack_require__(77322);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(41050);
// EXTERNAL MODULE: ./utils/token/formatBalance.ts
var formatBalance = __webpack_require__(95487);
;// CONCATENATED MODULE: ./utils/swap/computeIdealPrice.ts


var computeIdealPriceTokenIn = function(lpTokenReserves, tokenIn, tokenOut) {
    var rawPrice = (0,bignumber/* default */.Z)(1);
    var decimalIn = tokenIn.decimal;
    var decimalOut = tokenOut.decimal;
    for(var i = 0; i <= lpTokenReserves.length - 1; i++){
        var amount = lpTokenReserves[i];
        var rawReserveOfTokenA = amount.tokenA;
        var rawReserveOfTokenB = amount.tokenB;
        rawPrice = rawPrice.multipliedBy(rawReserveOfTokenB.dividedBy(rawReserveOfTokenA));
    }
    var price = decimalIn === decimalOut ? rawPrice : (0,formatBalance/* getTokenAmount */.yS)(rawPrice, decimalOut - decimalIn);
    return price;
};

;// CONCATENATED MODULE: ./hooks/router/useIdealPriceOfTokenIn.ts









var useIdealPriceOfTokenIn = function(bestTradingPath, tokenIn, tokenOut) {
    // compute idead price of TokenA quoted by TokenB
    // e.g Dot/USDC
    // if the bestRoutePath were Dot/Astar <-> Astar/USDC then
    // ideal price of Dot quoted by USDC would be, Dot/Astar * Astar/USDC = Dot/USDC
    var factory = (0,useFactoryContract/* useFactoryContract */.M)();
    var api = (0,useApi/* useApi */.h_)();
    var keyringPair = (0,useAccounts/* useAccounts */.x)().keyringPair;
    var ref = (0,react.useState)(), lpReserves = ref[0], setReserves = ref[1];
    (0,react.useEffect)(function() {
        if (!bestTradingPath || !api || !keyringPair) {
            return;
        }
        var fetchReservedTokenAmountOflpTokenPair = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var reserves, i, ref, lpToken, pair, _reserves;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            reserves = [];
                            i = 0;
                            _state.label = 1;
                        case 1:
                            if (!(i < bestTradingPath.length - 1)) return [
                                3,
                                5
                            ];
                            return [
                                4,
                                factory === null || factory === void 0 ? void 0 : factory.query.getPair(bestTradingPath[i], bestTradingPath[i + 1])
                            ];
                        case 2:
                            lpToken = _state.sent();
                            if (!(lpToken === null || lpToken === void 0 ? void 0 : (ref = lpToken.value) === null || ref === void 0 ? void 0 : ref.ok)) return [
                                2
                            ];
                            pair = (0,getPairContract/* getPairContract */.A)(lpToken === null || lpToken === void 0 ? void 0 : lpToken.value.ok.toString(), keyringPair, api);
                            if (!pair) return [
                                2
                            ];
                            return [
                                4,
                                (0,getReserves/* getReserves */.S)(pair, bestTradingPath[i], bestTradingPath[i + 1])
                            ];
                        case 3:
                            _reserves = _state.sent();
                            if (!_reserves) return [
                                2
                            ];
                            reserves.push(_reserves);
                            _state.label = 4;
                        case 4:
                            i++;
                            return [
                                3,
                                1
                            ];
                        case 5:
                            return [
                                2,
                                reserves
                            ];
                    }
                });
            });
            return function fetchReservedTokenAmountOflpTokenPair() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchReservedTokenAmountOflpTokenPair().then(function(amount) {
            return setReserves(amount);
        });
    }, [
        api,
        bestTradingPath,
        factory,
        keyringPair
    ]);
    return (0,react.useMemo)(function() {
        if (!lpReserves || !tokenIn || !tokenOut) {
            return;
        }
        return computeIdealPriceTokenIn(lpReserves, tokenIn, tokenOut);
    }, [
        lpReserves,
        tokenIn,
        tokenOut
    ]);
};


/***/ }),

/***/ 72455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ useFetchTokenUSDCPrice; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(21157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(84911);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(41050);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./hooks/token/useGetWrappedTokenIfNative.ts
var useGetWrappedTokenIfNative = __webpack_require__(88830);
// EXTERNAL MODULE: ./hooks/token/useTokens.ts
var useTokens = __webpack_require__(78669);
// EXTERNAL MODULE: ./hooks/graph/useBestTrade.ts + 5 modules
var useBestTrade = __webpack_require__(4393);
// EXTERNAL MODULE: ./hooks/graph/useBuildGraph.ts + 5 modules
var useBuildGraph = __webpack_require__(61033);
// EXTERNAL MODULE: ./constants/tradeType.ts
var tradeType = __webpack_require__(36819);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(43795);
;// CONCATENATED MODULE: ./state/tokenPrice.ts



var currentTokenPrices = (0,es/* atom */.cn)({
    key: "currentTokenPrices",
    default: []
});
var useTokenPrice = function(token) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,es/* useRecoilState */.FV)(currentTokenPrices), 1), tokenPrices = ref[0];
    return (0,react.useMemo)(function() {
        if (!tokenPrices || (tokenPrices === null || tokenPrices === void 0 ? void 0 : tokenPrices.length) < 1 || !token) {
            return;
        }
        return tokenPrices.find(function(x) {
            return x.address == token.address;
        });
    }, [
        tokenPrices,
        token
    ]);
};
var useTokenPrices = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,es/* useRecoilState */.FV)(currentTokenPrices), 2), tokenPrices = ref[0], setTokenPrices = ref[1];
    return [
        tokenPrices,
        setTokenPrices
    ];
};

// EXTERNAL MODULE: ./hooks/router/useIdealPriceOfTokenIn.ts + 1 modules
var useIdealPriceOfTokenIn = __webpack_require__(68574);
// EXTERNAL MODULE: ./state/blockNumber.ts
var state_blockNumber = __webpack_require__(70418);
;// CONCATENATED MODULE: ./hooks/token/useFetchTokenUSDCPrice.ts












var useFetchTokenUSDCPrice = function(token) {
    var wrappedToken = (0,useGetWrappedTokenIfNative/* useGetWrappedTokenIfNative */.q)(token);
    var ref = (0,_sliced_to_array/* default */.Z)(useTokenPrices(), 2), _ = ref[0], setTokenPrices = ref[1];
    var tokenPrice = useTokenPrice(token);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,state_blockNumber/* useBlockNumber */.O)(), 1), blockNumber = ref1[0];
    var tokens = (0,useTokens/* useAllTokens */.e)();
    var USDC = (0,react.useMemo)(function() {
        return tokens.find(function(token) {
            return token.symbol === "USDC";
        });
    }, [
        tokens
    ]);
    var graph = (0,useBuildGraph/* useBuildGraph */.v)();
    // BIG_ONE's instance is updated when blockNumber updated.
    // thus each time blockNumber is updated, re-calculate price of given token
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var BIG_ONE = (0,react.useMemo)(function() {
        return new bignumber/* default */.Z(1);
    }, [
        blockNumber
    ]);
    var bestTradePath = (0,useBestTrade/* useBestTrade */.P)({
        tokenA: token,
        tokenB: USDC,
        amountIn: BIG_ONE,
        amountOut: undefined,
        graph: graph,
        tradeType: tradeType/* TradeType.EXACT_INPUT */.Y.EXACT_INPUT
    }).bestTradePath;
    var price = (0,useIdealPriceOfTokenIn/* useIdealPriceOfTokenIn */.V)(bestTradePath, token, USDC);
    (0,react.useEffect)(function() {
        if ((price === null || price === void 0 ? void 0 : price.gt(0)) && token && setTokenPrices && token.isNative && wrappedToken) {
            setTokenPrices(function(prev) {
                return (0,_to_consumable_array/* default */.Z)(prev).concat([
                    {
                        address: token.address,
                        price: price === null || price === void 0 ? void 0 : price.toFixed()
                    },
                    {
                        address: wrappedToken === null || wrappedToken === void 0 ? void 0 : wrappedToken.address,
                        price: price === null || price === void 0 ? void 0 : price.toFixed()
                    }
                ]);
            });
        }
        if ((price === null || price === void 0 ? void 0 : price.gt(0)) && token && setTokenPrices && !token.isNative) {
            setTokenPrices(function(prev) {
                return (0,_to_consumable_array/* default */.Z)(prev).concat([
                    {
                        address: token.address,
                        price: price === null || price === void 0 ? void 0 : price.toFixed()
                    }
                ]);
            });
        }
    }, [
        price,
        setTokenPrices,
        token,
        wrappedToken
    ]);
    return tokenPrice;
};


/***/ }),

/***/ 65293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getPairContract; }
/* harmony export */ });
/* harmony import */ var _utils_types_contracts_pair_contract__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58269);
/* harmony import */ var _env_sentry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37572);


var getPairContract = function(address, keyringPair, api) {
    try {
        return new _utils_types_contracts_pair_contract__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(address, keyringPair, api);
    } catch (error) {
        (0,_env_sentry__WEBPACK_IMPORTED_MODULE_1__/* .sentryLogError */ .P)(error);
        console.error("Failed to get contract", error);
        return null;
    }
};


/***/ })

}]);